import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2, AlertTriangle, CalendarDays } from "lucide-react";
import { DESTINATIONS } from "../../data/destinations";

const CAT_LABEL = { travel: "Travel", yoga: "Yoga", wellness: "Wellness & Party", adventure: "Adventure" };
const imageFor = (id) => DESTINATIONS.find((d) => d.id === id)?.image;

export const ItineraryResult = ({ result, requestedDays, onNavigate }) => {
  const totalDays = result.stops.reduce((s, x) => s + x.days, 0);

  return (
    <div data-testid="ai-itinerary-result" className="mt-6">
      <div
        data-testid="ai-feasibility"
        className={`flex items-start gap-2 rounded-xl p-4 text-sm ${
          result.feasible ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"
        }`}
      >
        {result.feasible ? <CheckCircle2 size={18} className="mt-0.5 flex-shrink-0" /> : <AlertTriangle size={18} className="mt-0.5 flex-shrink-0" />}
        <div>
          <p className="font-medium">
            {result.feasible ? `Doable in ${requestedDays} days` : "Heads up — this route is tight"}
            <span className="ml-2 font-normal opacity-80">· {totalDays} days planned across {result.stops.length} stops</span>
          </p>
          {result.notes && <p className="mt-1 opacity-90">{result.notes}</p>}
        </div>
      </div>

      <p className="mt-4 text-sm text-brand-inkSoft">{result.summary}</p>

      <ol className="mt-5 space-y-3">
        {result.stops.map((s, i) => (
          <li key={s.id}>
            <Link
              to={`/escape/${s.id}`}
              onClick={onNavigate}
              data-testid={`ai-stop-${s.id}`}
              className="group flex items-stretch gap-3 rounded-xl border border-brand-line p-3 transition hover:border-brand-ink"
            >
              <div className="relative h-20 w-20 flex-shrink-0 overflow-hidden rounded-lg bg-brand-bg2">
                <img src={imageFor(s.id)} alt={s.title} className="h-full w-full object-cover" />
                <span className="absolute left-1 top-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-brand-ink text-[11px] font-medium text-white">
                  {i + 1}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-display text-lg leading-tight text-brand-ink truncate">{s.title}</p>
                  <span className="inline-flex flex-shrink-0 items-center gap-1 rounded-full bg-brand-bg2 px-2.5 py-1 text-[11px] font-medium text-brand-ink">
                    <CalendarDays size={12} /> {s.days}d
                  </span>
                </div>
                <p className="text-xs text-brand-inkSoft">{s.country} · {CAT_LABEL[s.category] || s.category}</p>
                {s.why && <p className="mt-1 line-clamp-2 text-xs text-brand-ink/80">{s.why}</p>}
              </div>
              <ArrowUpRight size={16} className="mt-1 flex-shrink-0 text-brand-inkSoft transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default ItineraryResult;
